export default __webpack_public_path__ + "static/media/fraud-support.87d1e505.svg";